import { ProgressEvent } from 'src/app/shared/models/progress/progressEvent';

import _ from 'lodash';

export class ProgressEventHandler {
  public progressEvents: ProgressEvent[];
  private initialLoadTime: number;
  private readonly minimumLoadTime: number = 1000;

  get totalEventLength(): number {
    return this.progressEvents.length;
  }

  get completedEventLength(): number {
    return _.filter(this.progressEvents, { isResolved: true }).length;
  }

  get progressStartedTime(): number {
    return this.initialLoadTime;
  }

  get progressMinimumLoadTime(): number {
    return this.minimumLoadTime;
  }

  constructor() {
    this.progressEvents = new Array<ProgressEvent>();
  }

  addNewEvent(eventName: string): void {
    if (this.totalEventLength === 0) {
      this.initialLoadTime = performance.now();
    }
    this.progressEvents.push(ProgressEvent.parse(eventName));
  }

  resolveEvent(eventName: string): void {
    if (eventName) {
      let event = _.find(this.progressEvents, { name: eventName, isResolved: false });
      if (event) {
        event.isResolved = true;
      }
    }
  }

  allEventsAreResolved(): boolean {
    return !_.filter(this.progressEvents, function (progressEvent: ProgressEvent) {
      return !progressEvent.isResolved;
    }).length;
  }

  clearEvents(callback): void {
    var timeToLoad = this.getTotalTimeToLoad();
    if (timeToLoad >= this.minimumLoadTime) {
      callback();
    } else {
      setTimeout(function () {
        callback();
      }, this.minimumLoadTime - timeToLoad);
    }
    this.progressEvents = new Array<ProgressEvent>();
  }

  getTotalTimeToLoad() {
    return performance.now() - this.initialLoadTime;
  }
}
